import { useSelector } from "react-redux";
import HorizantalBar from "../../../components/horizantalBar/HorizantalBar";
import PageLink from "../../../components/pageLink/PageLink";
import { allowedTabs } from "../../../constants/permissionCatalog";
import UserNavigator from "../../../navigation/UserNavigator";
import styles from "./userSettings.module.css";

const UserSettings = () => {
  const { rolePermissions } = useSelector((state) => state.user);
  const tabs = allowedTabs("users", rolePermissions);

  return (
    <div className={styles.container}>
      <HorizantalBar>
        <div className={styles.linksWrapper}>
          {tabs.map((tab) => (
            <div key={tab.id} className={styles.linkWrapper}>
              <PageLink destination={`/dashboard/users/${tab.path}`}>{tab.label}</PageLink>
            </div>
          ))}
        </div>
      </HorizantalBar>
      <UserNavigator />
    </div>
  );
};

export default UserSettings;
